import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import React, { memo, useContext, useEffect, useState } from "react"
//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

const host = window.location.protocol + "//" + window.location.host;
import Config, { ActiveClient } from "../../config";

var LogoSet = (ActiveClient) ? Config[ActiveClient] : Config["cargills"];
//console.log(LogoSet);

var logo, logoLightPng, logoLightSvg, logoDark;
import(`../../assets/images/logo/${LogoSet.logo}`).then(data => {
  logo = host + data.default; //console.log(logo);
});
import(`../../assets/images/logo/${LogoSet.logoLightPng}`).then(data => {
  logoLightPng = host + data.default; //console.log(logoLightPng);
});
import(`../../assets/images/logo/${LogoSet.logoLightSvg}`).then(data => {
  logoLightSvg = host + data.default; //console.log(logoLightPng);
});
import(`../../assets/images/logo/${LogoSet.logoDark}`).then(data => {
  logoDark = host + data.default; //console.log(logoLightPng);
});
import { Context } from "app-contexts/CommonContexts"
const crypto = require('crypto');

import { useHistory } from 'react-router-dom';


const Sidebar = memo(props => {

  const {
    isHeadOffice, approvalNotifications, setUseEffecttrigger, setMenus, getCommonNotifications, menus
  } = useContext(Context);
  let history = useHistory();

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const userName = obj[2];
        const authToken = localStorage.getItem("authToken");
        const ApiURL = window.Links.ApiURL;

        const response = await fetch(`${ApiURL}login/menu/${userName}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`,
          },
        });

        if (response.status == 200) {

          const responseData = await response.json();

          // const cipher = crypto.createCipher('aes-256-cbc', 'd6F3Efeq');
          // let encryptedData = cipher.update(JSON.stringify(responseData.data), 'utf8', 'hex');
          // encryptedData += cipher.final('hex');

          // localStorage.setItem("encryptedData", encryptedData);
          setMenus(responseData.data.filter(menu => menu.strMenuTag != "" && menu.strMenuTag != null));
          setUseEffecttrigger(prev => !prev);

        } else if (response.status == 401) {
          alert("Session Expired. Please Login Again");
          localStorage.clear();
          history.push("/login");
        } else {
          // handle other statuses if needed
        }
      } catch (error) {
        console.error("Error fetching menu items:", error);
        localStorage.clear();
        history.push("/login");
      }
    };

    fetchMenuItems();
  }, []);

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logo} alt="" width="30" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" style={{ maxHeight: '60px', maxWidth: '170px', marginTop: '0px', padding: '0' }} />
              <hr style={{ margin: 0 }} />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100" >
          {props.type !== "condensed" ? <SidebarContent menuItems={props.menuItems} /> : <SidebarContent menuItems={props.menuItems} />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
})

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
